import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from './../../common/Pagination';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import apiUrls from './../apiUrls';

class Table extends Component {
    static propTypes = {
        elements: PropTypes.array,
        handleSort: PropTypes.func,
        handleUpdateFormValue: PropTypes.func,
        isFetchingElements: PropTypes.bool,
        handleShowForm: PropTypes.func,
        handleShowDelete: PropTypes.func,
        totalPages: PropTypes.number,
        selectedPage: PropTypes.number,
        elementsPerPage: PropTypes.number,
        sortColumn: PropTypes.string,
        sortType: PropTypes.string,
        handleChangeAttribute: PropTypes.func,
        handleInlineChange: PropTypes.func,
        handleDayChange: PropTypes.func,
        handleViewProperty: PropTypes.func,
        statuses: PropTypes.array,
        isFetchingStatuses: PropTypes.array,
        handleChangeFilter: PropTypes.func,
        processedElements: PropTypes.array
    };

    renderTableHeader(label, name, style, sortable = true) {
        const { handleSort, sortColumn, sortType } = this.props;

        let icon = <i className="fas fa-sort" />;
        if (sortColumn === name) {
            if (sortType === 'asc') {
                icon = <i className="fas fa-sort-up" />;
            } else {
                icon = <i className="fas fa-sort-down" />;
            }
        }

        if (sortable) {
            return <th style={style}><span onClick={handleSort.bind(this, name)}>{label} {icon}</span></th>;
        }

        return <th style={style}>{label}</th>;
    }

    renderData() {
        const { processedElements, isFetchingElements, handleShowForm, selectedPage, elementsPerPage,
            statuses, isFetchingStatuses } = this.props;

        if (isFetchingElements || isFetchingStatuses) {
            return (
                <tr>
                    <td colSpan="7"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (processedElements.length === 0) {
            return (
                <tr>
                    <td colSpan="7">No Results</td>
                </tr>
            );
        }

        let statusesOptions = [];
        for (let i = 0; i < statuses.length; i++) {
            statusesOptions.push(<option value={statuses[i]['id']}>{statuses[i]['name']}</option>);
        }

        let data = [];
        let startIndex = (selectedPage - 1) * elementsPerPage;
        for (let i = startIndex; i < processedElements.length && i < startIndex + elementsPerPage; i++) {
            if (processedElements[i]['order']['production_status_id'] === null || processedElements[i]['order']['production_status_id'] === '') {
                continue;
            }

            let artworks = [];
            for (let j = 0; j < processedElements[i]['estimateFiles'].length; j++) {
                artworks.push(
                    <li className="artwork-link">
                        <a href={apiUrls.downloadFile + '?id=' + processedElements[i]['estimateFiles'][j]['id']}>
                            {processedElements[i]['estimateFiles'][j]['filename']}
                        </a>
                    </li>
                );
            }

            data.push(
                <tr key={i}>
                    <td>{processedElements[i]['id']}</td>
                    <td>{processedElements[i]['order_id']}</td>
                    <td>{processedElements[i]['product_description']}</td>
                    <td>{processedElements[i]['order']['customer_name']}</td>
                    <td className="artworks"><ol>{artworks}</ol></td>
                    <td>{processedElements[i]['order']['customer_po']}</td>
                    <td>{processedElements[i]['order']['production_status_name']}</td>
                    <td>{processedElements[i]['order']['shipping_method_name']}</td>
                    <td>
                        <div className="actions">
                            <Tooltip title="Edit" position="bottom" arrow size="small" className="action-tooltip">
                                <i className="fas fa-edit" onClick={handleShowForm.bind(this, processedElements[i]['order_id'], null)} />
                            </Tooltip>
                        </div>
                    </td>
                </tr>
            );
        }

        return data;
    }

    renderSearchField(name) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <input type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} />
            </th>
        );
    }

    renderSearchSelect(name, options) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <select type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} >
                    {options.map((option, index) => {
                        return (
                            <option key={index} value={option['value']}>{option['label']}</option>
                        );
                    })}
                </select>
            </th>
        );
    }

    render() {
        const { processedElements, totalPages, selectedPage, elementsPerPage } = this.props;
        return (
            <div id="tables-container" className="production-container">
                <div className="table-container table-hover">
                    <table id="titles-table" className="table table-sm">
                        <thead>
                            <tr>
                                {this.renderTableHeader('Job ID', 'id', { width: '6%' })}
                                {this.renderTableHeader('Order ID', 'order_id', { width: '6%' })}
                                {this.renderTableHeader('Description', 'product_description', { width: 'calc(28% - 50px)' })}
                                {this.renderTableHeader('Customer', 'customer_name', { width: '14%' })}
                                {this.renderTableHeader('Artworks', 'artworks', { width: '14%' }, false)}
                                {this.renderTableHeader('PO', 'customer_po', { width: '9%' })}
                                {this.renderTableHeader('Status', 'production_status_name', { width: '11%' })}
                                {this.renderTableHeader('Shipping Method', 'shipping_method', { width: '12%' })}
                                <th style={{ width: 50 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {this.renderSearchField('id')}
                                {this.renderSearchField('order_id')}
                                {this.renderSearchField('product_description')}
                                {this.renderSearchField('customer_name')}
                                <th className="search-th"></th>
                                {this.renderSearchField('customer_po')}
                                {this.renderSearchField('production_status_name')}
                                {this.renderSearchField('shipping_method')}
                                <th className="search-th"></th>
                            </tr>
                            {this.renderData()}
                        </tbody>
                    </table>
                    <Pagination.Container
                        totalItems={processedElements.length}
                        totalPages={totalPages}
                        selectedPage={selectedPage}
                        elementsPerPage={elementsPerPage}
                    />
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default Table;
